import React from 'react'

const MessageLineIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.8 1H5.2C2.4 1 1 2.4 1 5.2V14.3C1 14.685 1.315 15 1.7 15H10.8C13.6 15 15 13.6 15 10.8V5.2C15 2.4 13.6 1 10.8 1Z" stroke="#292D32" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.5 6.25H11.5" stroke="#292D32" strokeWidth="1.2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.5 9.75H9.4" stroke="#292D32" strokeWidth="1.2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default MessageLineIcon